import 'ima.js-babel6-polyfill'; // https://phabricator.babeljs.io/T3041

window.Promise.prototype.finally = function(callback) {
  return this.then(
    value => this.constructor.resolve(callback()).then(() => value),
    reason =>
      this.constructor.resolve(callback()).then(() => {
        throw reason;
      })
  );
};
